/* global moment */
/* global _ */

// 文件类型 ICON
const FILE_TYPE_ICON = {
  doc: 'http://image.yitong.com/ytw/youshiwangxiao/school-live/doc_word.png',
  pdf: 'http://image.yitong.com/ytw/youshiwangxiao/school-live/doc_pdf.png',
  pptx: 'http://image.yitong.com/ytw/youshiwangxiao/school-live/doc_ppt.png',
  xlsx: 'http://image.yitong.com/ytw/youshiwangxiao/school-live/doc_xls.png'
}

/**
 * 秒 转 分
 *
 * @export
 * @param {Number} s - 单位秒
 * @returns {Number}
 */
export function second2minute(s) {
  return parseInt(moment.duration(s * 1000).asMinutes())
}

/**
 * 时间格式化
 *
 * @export
 * @param {Number} timestamp - 时间戳
 * @returns {String}
 */
export function formatDate(timestamp, format = 'YYYY-MM-DD HH:mm:ss') {
  return moment(timestamp).format(format)
}

/**
 * 获取封面图 url
 *
 * @export
 * @param {Object} val -
 * @returns {String}
 */
export function getCourseCoverUrl(val) {
  return _.get(val, 'source[1].uri') || _.get(val, 'source[0].uri') || ''
}

/**
 * 获取文件类型图标
 *
 * @export
 * @param {Object} [val={}]
 * @returns {String}
 */
export function getFileTypeIcon(val = {}) {
  return (
    FILE_TYPE_ICON[val.type] ||
    'http://image.yitong.com/ytw/youshiwangxiao/school-live/doc_word.png'
  )
}